module.exports = __webpack_public_path__ + "static/img/Turkey.a59f787.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flag/Turkey.png
// module id = PMKt
// module chunks = 1